import { render, staticRenderFns } from "./list.vue?vue&type=template&id=44c4fda9&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=44c4fda9&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c4fda9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44c4fda9')) {
      api.createRecord('44c4fda9', component.options)
    } else {
      api.reload('44c4fda9', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=44c4fda9&scoped=true", function () {
      api.rerender('44c4fda9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/closeReturn/list.vue"
export default component.exports